import { render } from "./S175368.vue?vue&type=template&id=d55a08a8"
const script = {}
script.render = render

export default script